module.exports = __webpack_public_path__ + "img/05_feet_Isonoe_silver.898b0a3e.png";